import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getIsFiltersApplied, getSearchType } from 'modules/sapiSearch/selectors';
import { SearchType } from 'modules/sapiSearch/utils';
import { getLayout } from 'modules/search/selectors';
import { LayoutType } from 'modules/search/types';
import { showNearestResults } from 'utils/map';
import { Button, Variant } from '@daedalus/atlas/Button';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "b326sfd",
  propsAsIs: false
});
const mapNoResults = defineMessages({
  noResultsInThisArea: {
    id: 'mapNoResults.noResultsInThisArea',
    defaultMessage: 'No results in this area'
  },
  noMoreResultsInThisArea: {
    id: 'mapNoResults.noMoreResultsInThisArea',
    defaultMessage: 'No more results in this area'
  }
});
const BodyMessage = ({
  isFiltersApplied
}: {
  isFiltersApplied: boolean;
}) => {
  if (isFiltersApplied) {
    return <FormattedMessageWrapper id="mapNoResults.tryRemoveFilters" defaultMessage="Try adjusting your search criteria or removing some filters." />;
  }
  return <FormattedMessageWrapper id="mapNoResults.tryChangeArea" defaultMessage="Try changing your search area." values={{
    br: () => ''
  }} />;
};
interface Props {
  buttonVariant?: Variant;
}
export const NoResults = ({
  buttonVariant
}: Props) => {
  const {
    formatMessage
  } = useIntl();
  const searchType = useSelector(getSearchType);
  const isAreaSearch = searchType === SearchType.Area;
  const isFiltersApplied = useSelector(getIsFiltersApplied);
  const dispatch = useDispatch();
  const layout = useSelector(getLayout);
  useEffect(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.ShowNearestResults,
      action: Action.Viewed
    }));
  }, [dispatch]);
  const title = formatMessage(isAreaSearch ? mapNoResults.noMoreResultsInThisArea : mapNoResults.noResultsInThisArea);
  return <Flex.Column alignItems="center" gap="s500">
      <Text variant="titleL">{title}</Text>
      <Text variant="bodyM">
        {<BodyMessage isFiltersApplied={isFiltersApplied} />}
      </Text>
      {layout !== LayoutType.LIST && <ButtonWrapper>
          <Button variant={buttonVariant} size="xl" onClick={showNearestResults}>
            <FormattedMessageWrapper id="mapNoResults.showNearestResults" defaultMessage="Show nearest results" />
          </Button>
        </ButtonWrapper>}
    </Flex.Column>;
};

require("./NoResults.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./NoResults.tsx");